import refinementDropdown from './refinement-dropdown';
import categoryDropdown from './types/category-dropdown';

/**
 * @param {import('../../../../type-definitions').RefinementsData} refinements - refinements
 * @param {Array<import('../../../../type-definitions').Category>} categories - categories
 * @param {boolean} isCategorySearch - whether the search is based off a category
 * @param {import('../../../../interface/refinement-url-builder').default} refinementURLBuilder - url builder
 * @param {Object} seoUrlConfig - SEO exclude configuration
 * @returns {string} refinements dropdown HTML
 */
export default (refinements, categories, isCategorySearch, refinementURLBuilder, seoUrlConfig) => {
    return `
        <div class="refinement-dropdowns">
            <ul class="refinements-list toggle-list">
                ${
                    isCategorySearch
                        ? `
                        ${categories
                            .map(category =>
                                category.children.length > 0 ? categoryDropdown(category, isCategorySearch) : ''
                            )
                            .join('')}`
                        : ''
                }

                ${
                    refinements
                        ?.map(refinement => refinementDropdown(refinement, refinementURLBuilder, seoUrlConfig))
                        .join('') || ''
                }
            </ul>
        </div>
    `;
};
